import * as React from 'react';

function SvgCompareStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.577 6.5h-5.154v17.615h5.154V6.5zm-1.001 1v15.615h-3.153V7.5h3.153zm2.77 3.154H24.5v13.461h-5.154V10.654zM23.5 23.115V11.653h-3.153v11.462h3.153zM5.5 13.423h5.154v10.692H5.5V13.423zm4.153 9.692v-8.692H6.5v8.692h3.153z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgCompareStroke;
